import Hosting from './Hosting';

export default Hosting;
